import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([['lg:grid-cols-' + _ctx.gridColumns, _ctx.contrast ? 'divide-white' : 'divide-black'], "max-h-screen-90 relative z-10 grid auto-rows-fr divide-y divide-opacity-50 overflow-hidden lg:h-160 lg:divide-y-0 lg:divide-x"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}